const CATEGORY_LABELS = {
    partidos: "Partidos Jugados",
    ganados: "Partidos Ganados",
    pts: "Puntos",
    puntos: "Puntos",
    rt: "Rebotes Totales",
    ro: "Rebotes Ofensivos",
    rd: "Rebotes Defensivos",
    ast: "Asistencias",
    asistencias: "Asistencias",
    tch: "Tiros de Campo Hechos",
    tth: "Triples Hechos",
    triplesHechos: "Triples Hechos",
    tdh: "Dobles Hechos",
    tlh: "Libres Hechos",
    stl: "Robos",
    robos: "Robos",
    libresHechos: "Libres Hechos",
    bls: "Tapas",
    winPerc: "Win %",
};

const TECNICO_CATEGORY_LABELS = {
    partidos: "Partidos Dirigidos",
    winPerc: "Gan %",
};

function getLabel(categoria, isTecnico) {
    if (isTecnico && TECNICO_CATEGORY_LABELS[categoria]) return TECNICO_CATEGORY_LABELS[categoria];
    return CATEGORY_LABELS[categoria] || String(categoria).toUpperCase();
}

function getTone(posicion) {
    if (posicion === 1) return "gold";
    if (posicion === 2) return "silver";
    if (posicion === 3) return "bronze";
    return "green";
}

const TONE_BADGE_CLASSES = {
    gold: "bg-yellow-300/90 text-[#2d2211] border-yellow-500/60",
    silver: "bg-slate-200 text-slate-800 border-slate-300",
    bronze: "bg-amber-400/70 text-[#3d2b1f] border-amber-700/50",
    green: "bg-[#102216] text-green-400 border-green-500/40",
};

function PositionBadge({ label, posicion, cantidad, showAmount }) {
    const tone = getTone(posicion);
    const content = showAmount
        ? `#${posicion} · ${label}: ${cantidad}`
        : `${label} · #${posicion}`;

    return (
        <span className={`rounded px-3 py-1 text-[10px] font-black uppercase tracking-wide border ${TONE_BADGE_CLASSES[tone]}`}>
            {content}
        </span>
    );
}

export default function JugadorPositionsCard({ positions = [], title = "Posiciones en Récords", showAmount = false, isTecnico = false }) {
    if (!Array.isArray(positions) || positions.length === 0) {
        return null;
    }

    const sortedPositions = [...positions].sort((a, b) => (a.posicion ?? 0) - (b.posicion ?? 0));

    return (
        <section className="mb-10 rounded-xl border border-white/10 bg-[#102216] overflow-hidden">
            <div className="px-5 py-4 border-b border-white/10 bg-white/5 text-center">
                <h3 className="text-sm font-bold text-green-500 uppercase tracking-wider">{title}</h3>
            </div>

            <div className="p-4 sm:p-5 flex flex-wrap items-center gap-2">
                {sortedPositions.map((item, index) => (
                    <PositionBadge
                        key={`badge-${item.categoria}-${item.posicion}-${index}`}
                        label={getLabel(item.categoria, isTecnico)}
                        posicion={item.posicion}
                        cantidad={item.cantidad}
                        showAmount={showAmount}
                    />
                ))}
            </div>
        </section>
    );
}
